export default __webpack_public_path__ + "static/media/leaf.27a7123e.png";